// components/ToastNotification.jsx
import React, { useState, useEffect } from 'react';
import './toastnotification.scss';

export const ToastNotification = ({ message, type = 'success', duration = 3000, onClose }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
            if (onClose) setTimeout(onClose, 300);
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <div className={`toast-notification ${type} ${isVisible ? 'show' : 'hide'}`}>
            <div className="toast-icon">
                {type === 'success' && '✓'}
                {type === 'error' && '✗'}
                {type === 'info' && 'ℹ'}
            </div>
            <div className="toast-content">
                <p className="toast-message">{message}</p>
            </div>
            <div className="toast-progress-bar" style={{ animationDuration: `${duration}ms` }}></div>
        </div>
    );
};

// Container globale per i toast
let toastContainer = null;
let toastQueue = [];

export const showToast = (message, type = 'success', duration = 3000) => {
    if (toastContainer) {
        toastContainer(message, type, duration);
    } else {
        toastQueue.push({ message, type, duration });
    }
};

export const ToastContainer = () => {
    const [toasts, setToasts] = useState([]);

    useEffect(() => {
        toastContainer = (message, type, duration) => {
            const id = Date.now();
            setToasts(prev => [...prev, { id, message, type, duration }]);
        };
        
        // Processa toast in coda
        toastQueue.forEach(toast => toastContainer(toast.message, toast.type, toast.duration));
        toastQueue = [];

        return () => {
            toastContainer = null;
        };
    }, []);

    const removeToast = (id) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    };

    return (
        <div className="toast-container">
            {toasts.map(toast => (
                <ToastNotification
                    key={toast.id}
                    message={toast.message}
                    type={toast.type}
                    duration={toast.duration}
                    onClose={() => removeToast(toast.id)}
                />
            ))}
        </div>
    );
};
